import React from "react";

const FiltresArtisanat = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedFilters = { ...filters };

    if (type === "checkbox") {
      updatedFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      updatedFilters[name] = value;
    }

    onChange(updatedFilters);
  };

  const uniqueTypeArt = [
    ...new Set(annonces.map((a) => a.typeArt).filter(Boolean)),
  ];

  const uniqueVille = [
    ...new Set(annonces.map((a) => a.ville).filter(Boolean)),
  ];

  return (
    <div>
      <h3>Type d'équipement</h3>
      {uniqueTypeArt.map((typeEquipement) => (
        <label key={typeEquipement}>
          <input
            type="checkbox"
            name="typeEquipement"
            value={typeEquipement}
            onChange={handleChange}
          />
          {typeEquipement}
        </label>
      ))}

      <h3>Ville</h3>
      {uniqueVille.map((ville) => (
        <label key={ville}>
          <input
            type="checkbox"
            name="ville"
            value={ville}
            onChange={handleChange}
          />
          {ville}
        </label>
      ))}

      <h3>Prix</h3>
      <label>
        Min:
        <input
          type="number"
          name="prixMin"
          value={filters.prixMin}
          onChange={handleChange}
          placeholder="Prix minimum"
        />
      </label>
      <label>
        Max:
        <input
          type="number"
          name="prixMax"
          value={filters.prixMax}
          onChange={handleChange}
          placeholder="Prix maximum"
        />
      </label>
    </div>
  );
};

export default FiltresArtisanat;
